import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';

const state = () => ({
  missions: [],
  mission: null,
  missionLoading: false,
  missionMetaGroups: [],
  missionMetaGroupsDisabled: [],
  missionICNotReady: [],
});

export default {
  mutations,
  actions,
  getters,
  state,
};
